module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAdklEQVQYlY3QOxKCYAxF4Y+MpcvBBdD7WAu2Wv60shexp3ZwO/YWhlLkzNwiuafIpCqlSA5osct5wg0PiFwW3NFgm2kwZGeDPS5+c8EzcF6QZtpAvUKs478DqsBrhTgF+hViH74v6BakDsN84xUnjHhnRhyz8wEXdRUiIhyhggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxwx/report/point.png
// module id = PXfT
// module chunks = 1